import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { DownloadSimple, FileCsv, FilePdf, FileXls } from "@phosphor-icons/react";

export default function Reports() {
  const [summary, setSummary] = useState(null);

  useEffect(() => { api.get("/reports/summary").then(({data}) => setSummary(data)); }, []);

  const downloadCsv = async () => {
    try {
      const token = localStorage.getItem("cbm_token");
      const r = await fetch(`${API}/reports/csv`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("Falha");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `relatorio_confidence_${new Date().toISOString().slice(0,10)}.csv`; a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV exportado");
    } catch (e) { toast.error("Falha ao exportar"); }
  };

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Relatórios</div>
        <h1 className="font-heading font-extrabold text-4xl">Exportação e sumário</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-5 rounded-sm border card-hover cursor-pointer" onClick={downloadCsv} data-testid="export-csv-btn">
          <FileCsv size={32} weight="bold" className="text-[#0A3B2C]" />
          <div className="font-heading font-bold mt-3">Exportar CSV</div>
          <div className="text-xs text-muted-foreground mt-1">Baixa a tabela completa de descobertas.</div>
          <Button className="mt-4 w-full rounded-sm bg-[#0A3B2C] hover:bg-[#083527]"><DownloadSimple size={14} className="mr-2" /> Baixar CSV</Button>
        </Card>
        <Card className="p-5 rounded-sm border opacity-60">
          <FilePdf size={32} weight="bold" className="text-muted-foreground" />
          <div className="font-heading font-bold mt-3">PDF</div>
          <div className="text-xs text-muted-foreground mt-1">Disponível na próxima versão.</div>
          <Button disabled className="mt-4 w-full rounded-sm">Em breve</Button>
        </Card>
        <Card className="p-5 rounded-sm border opacity-60">
          <FileXls size={32} weight="bold" className="text-muted-foreground" />
          <div className="font-heading font-bold mt-3">Excel</div>
          <div className="text-xs text-muted-foreground mt-1">Disponível na próxima versão.</div>
          <Button disabled className="mt-4 w-full rounded-sm">Em breve</Button>
        </Card>
      </div>

      {summary && (
        <Card className="p-6 rounded-sm border">
          <h3 className="font-heading font-bold text-lg mb-4">Sumário do período</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-sm">
            <div><div className="text-[10px] uppercase text-muted-foreground">Total resultados</div><div className="font-heading font-bold text-2xl">{summary.total}</div></div>
            <div><div className="text-[10px] uppercase text-muted-foreground">Risco alto</div><div className="font-heading font-bold text-2xl text-[#DC2626]">{summary.por_risco.alto}</div></div>
            <div><div className="text-[10px] uppercase text-muted-foreground">Risco médio</div><div className="font-heading font-bold text-2xl text-[#B45309]">{summary.por_risco.medio}</div></div>
            <div><div className="text-[10px] uppercase text-muted-foreground">Risco baixo</div><div className="font-heading font-bold text-2xl text-[#047857]">{summary.por_risco.baixo}</div></div>
            <div className="col-span-2"><div className="text-[10px] uppercase text-muted-foreground">Fontes analisadas</div><div className="text-sm mt-1">{summary.fontes.join(", ") || "—"}</div></div>
            <div className="col-span-2"><div className="text-[10px] uppercase text-muted-foreground">Termos utilizados</div><div className="text-sm mt-1">{summary.termos.slice(0,10).join(", ") || "—"}</div></div>
          </div>
          <div className="mt-4 pt-4 border-t text-[10px] text-muted-foreground">{summary.aviso}</div>
        </Card>
      )}
    </div>
  );
}
